// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import data_control from "../../../../../engines/libs/data_control";
import LotteryBaseLayer from "../common/LotteryBaseLayer";
import { HappyWinDataManage } from "./data/HappyWinDataManage";
import { HappyWinKind } from "./data/HappyWinKind";
import HappyWinItemBase from "./HappyWinItemBase";
import HappyWinItemCom from "./HappyWinItemCom";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HappyWinLayer extends LotteryBaseLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeCombinationLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout: cc.Node = null;

    /** 牌型数据 */
    private cardData: HappyWinKind.CardTypeData = new HappyWinKind.CardTypeData();

    /** 参照区是否已显示 */
    private bReferAreaShow = false;

    // onLoad () {}

    start () {
        super.start();

        this.resetData();
    }

    // update (dt) {}

    resetData() {
        this.bReferAreaShow = false;
        super.resetData();

        this.getCardTypeData();
        this.resetReferArea();
    }

    /**
     * 获得牌型数据
     * @returns 
     */
    getCardTypeData() {
        const normalCount = 8;
        // 是否必中
        let bInfallible = false;

        let winArr: boolean[] = [];
        let numArr: number[] = [];
        let winCount = 0;
        for (let i = 0; i < normalCount; i++) {
            let idx = data_control.randomNumInt(1, HappyWinKind.WinProb.length-1);
            let winPropInfo = HappyWinKind.WinProb[idx];

            let prob = winPropInfo.prob;
            if (bInfallible) {
                prob = 1;
            }
            
            let bWin = false;
            // 中奖
            if (data_control.isHitProbability(prob)) {
                bWin = true;
                winCount++;
            } 

            winArr.push(bWin);
            numArr.push(winPropInfo.sum);
        }

        // 排除牌
        let excludeArr: number[] = [];
        if (winCount <= 0) {
            excludeArr.push(0, HappyWinKind.CardData.length-1);
        }
        
        this.cardData.card = HappyWinDataManage.generateCardTypeRefer(excludeArr);
        this.resetCombinationArea(winArr, numArr);
    }

    /**
     * 参照区
     */
    resetReferArea(){
        // this.nodeReferLayout.removeAllChildren();
        let children = this.nodeReferLayout.children;
        for (let i = 0; i < 2; i++) {
            let nodeItem = children[i];
            let script = nodeItem.getComponent(HappyWinItemBase);
            script.setData(this.cardData.card[i]);
        }
    }

    /**
     * 组合区
     */
    resetCombinationArea(winArr: boolean[], numArr: number[]) {
        // this.nodeCombinationLayout.removeAllChildren();
        
        let children = this.nodeCombinationLayout.children;
        let cardData = this.cardData.card;
        for (let i = 0; i < winArr.length; i++) {
            let bWin = winArr[i];
            let num = numArr[i];
            let retData = HappyWinDataManage.generateCardTypeCom(cardData, bWin);
            let nodeItem = children[i];
            let script = nodeItem.getComponent(HappyWinItemCom);
            script.setData(num, bWin, retData);
        }
    }

    checkJudge(pos1: cc.Vec2, pos2: cc.Vec2) {
        this.checkJudgeLottery(pos1, pos2);
    }

    checkJudgeNode(pos: cc.Vec2) {
        this.checkJudgeLottery(pos);
    }

    checkJudgeLottery(pos1: cc.Vec2, pos2: cc.Vec2 = null) {
        if (this.bFinishShow) {
            return;
        }
        if (!this.bReferAreaShow) {
            let referArr = [this.nodeReferLayout];
            let lenRefer = 0;
            for (let o of referArr) {
                let childrenRefer = o.children;
                lenRefer += childrenRefer.length;
                for (let i = 0; i < childrenRefer.length; i++) {
                    let childNode = childrenRefer[i];
                    let script = childNode.getComponent(HappyWinItemBase);
                    if (pos2) {
                        if (script.checkJudge(pos1, pos2)) {
                            lenRefer--;
                        }
                    } else {
                        if (script.checkJudgeNode(pos1)) {
                            lenRefer--;
                        }
                    }
                }
            }
            if (lenRefer <= 0) {
                this.bReferAreaShow = true;
            }
        }

        let childrenCom = this.nodeCombinationLayout.children;
        let lenCom = childrenCom.length;
        for (let i = 0; i < childrenCom.length; i++) {
            let childNode = childrenCom[i];
            let script = childNode.getComponent(HappyWinItemCom);
            if (script.isYetOpen()) {
                lenCom--;
            } else {
                if (pos2) {
                    if (script.checkJudge(pos1, pos2)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                } else {
                    if (script.checkJudgeNode(pos1)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                }
            }
            if (script.isYetOpen() && this.bReferAreaShow) {
                script.showAward();
            }
        }

        if (lenCom <= 0 && this.bReferAreaShow) {
            this.bFinishShow = true;
            this.showAllMask();
        }   
    }
}
